import styled from 'styled-components';
import { getColorWithAlpha, isDarkColor } from '@elfsight/lib-utils';
import { useSettings } from '@wu/widget-core';
import { useTranslation } from 'react-i18next';
import { formatNumberByLanguage } from '../utils';

export function VotesCount({ children }: { children: number }) {
  const { t } = useTranslation();
  const { textColor, language } = useSettings();

  const formattedCount = formatNumberByLanguage(children, language?.language);

  const color = isDarkColor(textColor)
    ? getColorWithAlpha(textColor, 0.5)
    : getColorWithAlpha(textColor, 0.7);

  return (
    <Container _color={color}>
      {children === 0
        ? t('Be the first to vote!')
        : t('{{votesCount}} votes', {
            votesCount: formattedCount
          })}
    </Container>
  );
}

const Container = styled.div<{
  _color: string;
}>`
  font-size: 14px;
  line-height: 1.28571;
  text-align: center;
  color: ${({ _color }) => _color};
`;
